import React from 'react';

export default function FarmMegaMenuContent({
  macroCategory,
  onViewGroup,
  onViewCrop,
  t,
  activeCategory,
  searchTerm,
  labelForGroup,
  labelForCrop
}) {
  if (!macroCategory) {
    return (
      <div className="w-[70%] p-6">
        <p className="text-sm text-gray-500 dark:text-gray-400">{t('common:noData', { ns: 'common', defaultValue: 'No data' })}</p>
      </div>
    );
  }

  const hasTwoColumns = macroCategory.groups.length <= 2;

  return (
    <section className="w-[70%] p-6 bg-gray-50 dark:bg-neutral-900 max-h-[420px] overflow-y-auto no-scrollbar">
      <div className={`grid gap-6 ${hasTwoColumns ? 'grid-cols-2' : 'grid-cols-2 xl:grid-cols-3'}`}>
        {macroCategory.groups.map((group) => {
          const groupLabel = labelForGroup(group);
          const groupActive = activeCategory === group.primaryCategoryId;
          const cropActive = !!searchTerm;

          return (
            <div key={group.id} className="min-w-0">
              <button
                type="button"
                onClick={() => onViewGroup(group)}
                className={`text-sm font-semibold transition ${
                  groupActive && !cropActive
                    ? 'text-green-700 dark:text-green-300'
                    : 'text-gray-900 hover:text-green-700 dark:text-gray-100 dark:hover:text-green-300'
                }`}
              >
                {groupLabel}
              </button>

              <ul className="mt-3 space-y-1.5">
                {group.items.map((item) => {
                  const cropLabel = labelForCrop(item);
                  const itemSelected = cropActive && searchTerm.toLowerCase() === item.toLowerCase();

                  return (
                    <li key={`${group.id}-${item}`}>
                      <button
                        type="button"
                        onClick={() => onViewCrop(item, group)}
                        className={`text-left text-sm transition ${
                          itemSelected
                            ? 'text-green-700 dark:text-green-300 font-medium'
                            : 'text-gray-600 hover:text-green-700 dark:text-gray-300 dark:hover:text-green-300'
                        }`}
                      >
                        {cropLabel}
                      </button>
                    </li>
                  );
                })}
              </ul>
            </div>
          );
        })}
      </div>
    </section>
  );
}
